import styled from 'styled-components'
import { Box } from '../../UI/Box'
import { barrySurface } from '../../../theme'

export const Chip = styled(Box)`
  display: flex;
  width: auto;
  flex: unset;

  padding: var(--units-4, 4px) var(--units-6, 6px);
  align-items: center;
  gap: var(--units-2, 2px);
  border-radius: 88px;
  border: 1px solid var(--stroke-secondary, #333);
  color: var(--text-primary, #fff);
  /* Web/Text/XS/Semibold */
  font-family: var(--family-space-grotesk, 'Space Grotesk');
  font-size: var(--Text-S-S-size, 8px);
  font-style: normal;
  font-weight: var(--weight-semibold, 600);
  line-height: var(--Text-S-S-line-height, 12px); /* 150% */
  ${barrySurface}
`
